import React from 'react';
import PatientSelectIcon from '../../../../../assets/svg/e-calendar/name-list-icon.svg';
import { useIntl } from 'react-intl';
import TStore from '../../../../../types/store';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../../../../../store/ducks/reservation-form-slice';
import { useFieldData } from '../reservation-form.utils';
import { SelectFieldProps } from '../../../../../types/reservation-form';
import { FormField } from '@hilbi/web-common/components/hilbi-form';
import PatientSelectOption from '@hilbi/web-common/components/e-visits/select/options/patient-select-option';

import CreatableSelect from '../../../../../components/creatable-select';

type PatientSelectProps = SelectFieldProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const PatientSelect: React.FunctionComponent<PatientSelectProps> = ({
  name,
  onPatientSearchString,
  patientOptions,
  disabled,
}) => {
  const { formatMessage } = useIntl();
  const { value, setValue, error } = useFieldData(name);

  return (
    <FormField
      disabled={disabled}
      error={error ? formatMessage({ id: error }) : ''}
      icon={PatientSelectIcon}
    >
      <CreatableSelect
        isDisabled={disabled}
        name={name}
        onChange={(v: any) => {
          setValue(v || null);
        }}
        options={patientOptions}
        formatCreateLabel={(val: string) =>
          formatMessage({ id: 'select_create_new' }) + '... ' + val
        }
        placeholder={formatMessage({ id: 'reservation_form_name_list_placeholder' })}
        components={{ Option: PatientSelectOption }}
        value={value}
        onInputChange={(v: string) => {
          v && onPatientSearchString(v);
        }}
        isClearable={true}
        noOptionsMessage={() => formatMessage({ id: 'no_options' })}
      />
    </FormField>
  );
};

const mapStateToProps = (state: TStore) => ({
  patientOptions: state.reservationForm.patientOptions,
});

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      onPatientSearchString: actions.onPatientSearchString,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(PatientSelect));
